import React from 'react';
// import {Link, IndexLink} from 'react-router';
import {Link, NavLink} from 'react-router-dom';
import {Collapse} from 'reactstrap';
import {
    UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem,
    Button, Progress,
    Nav, NavItem, Dropdown,
     ButtonDropdown, 
} from 'reactstrap';
import { TabContent, TabPane, Row, Col } from 'reactstrap';
import swal from 'sweetalert2';


// icons

import ScrollArea from '../scrollbar';


import './style.css';
import logo from  './logo.png';


import IconoFactura from '../../../images/icons_factura.svg';
import IconoTicket from '../../../images/icons_ticket.svg';

import IconoCotizacion from '../../../images/icons_cotizacion.svg';
import IconoUnidades from '../../../images/MENU_UNIDADES.svg';
import IconoCatalogos from '../../../images/MENU_CATALOGOS.svg';
import IconoMovimientos from '../../../images/MENU_MOVIMIENTOS.svg';
import IconoParametros from '../../../images/MENU_PARAMETROS.svg';

import IconoProductos from '../../../images/ICONS/ICONS_PRODUCTOSYSERVICIOS.svg';
import IconoCategorias from '../../../images/ICONS/ICONS_PRODUCTOSYSERVICIOS.svg';
import IconoFolios from '../../../images/ICONS/ICONS_FOLIOS DOCUMENTOS.svg';
import IconoEmbarques from '../../../images/ICONS/ICONS_VIAS DE EMBARQUE.svg';
import IconoLAB from '../../../images/ICONS/ICONS_CONCEPTO LAB.svg';
import IconoImpuestos from '../../../images/ICONS/ICONS_IMPUESTOS.svg';
import IconoDescuentos from '../../../images/ICONS/ICONS_PRODUCTOSYSERVICIOS.svg';

import IconoAlmacenes from '../../../images/ICONS/ICONS_ALMACENES.svg';
import IconoLineas from '../../../images/ICONS/ICONS_LINEAS.svg';
import IconoMarcas from '../../../images/ICONS/ICONS_MARCAS.svg';
import IconoEstilos from '../../../images/ICONS/ICONS_ESTILOS.svg';
import IconoColores from '../../../images/ICONS/ICONS_COLORES Y SABORES.svg';
import IconoMedidas from '../../../images/ICONS/ICONS_MEDIDAS.svg';

import IconoConceptos from '../../../images/ICONS/ICONS_TIPOS DE CONCEPTOS.svg';
import IconoTerminos from '../../../images/ICONS/ICONS_TERMINOS DE PAGO.svg';
import IconoMovimientos2 from '../../../images/ICONS/ICONS_TIPOS DE MOVIMIENTOS.svg';

import IconDashboard from 'react-icons/lib/md/dashboard';
import IconUndo from 'react-icons/lib/fa/chevron-left';
/*Falta */
import IconoInsidencia from '../../../images/icons_ticket.svg';
import IconoCompraEspecial from '../../../images/icons_ticket.svg';

import ReactSVG from 'react-svg';


import ModalTablas from '../../../components/catalogos/modal_tablas';
import ModalPlazos from '../../../components/plazosvencimientos/modal';
import ModalParametros from '../../../components/parametrossistema/modal';
import ModalDatosFactura from '../../../components/datosfactura/modal';

const NavHead = (props) => (
    <header className="nav-head">
        <NavLink to="/">
            <figure className="figure-140">
                <img src={logo} alt="Maxicomm" />
            </figure>
        </NavLink>
      
    </header>
);
const catalogos =[
         'Bancos',
         'Metodos de Pago',
         'Formas de Pago',
         'Codigos Postales',
         'Monedas',
         'Paises',
         'Impuestos',
         'Regimen Fiscal',
         'Usos de CFDI',
         'Tasas o Cuotas',
         'Unidades',
         'Relaciones',
         'Productos y Servicios',
         'Aduanas',
    ];

class NavList extends React.Component {
    constructor(props) {
        super(props);
          this.state = {
              menu: 0,
              submenu:0,
              modal:false,
              titulo:'error',
              catalogo:0,
              modal_plazos:false,
              modal_parametros:false,
              modal_datos_facutra:false,
              activeTab:1,
            };
         this.toggle = this.toggle.bind(this);
         this.toggle_modal = this.toggle_modal.bind(this);
         this.toggle_plazos = this.toggle_plazos.bind(this);
         this.toggle_parametros = this.toggle_parametros.bind(this);
         this.toggle_datos_factura = this.toggle_datos_factura.bind(this);
         this.modulo = this.modulo.bind(this);
         this.permisos_modal = this.permisos_modal.bind(this);
      }
  permisos_modal(id){
    if(parseInt(this.props.user.rol)==4){
        if(id==1){
            this.setState({
                modal_datos_facutra : !this.state.modal_datos_facutra,
            })
        }
        if(id==2){
            this.setState({
                modal_parametros : !this.state.modal_parametros,
            })
        }
        if(id==3){
            this.setState({
                modal_plazos : !this.state.modal_plazos,
            })
        }

    }else{
          swal("Advertencia!", "No Tienes el Permiso para Esta Accion!", "error");
    }
    
  }
  permisos(id){
    let bandera=false
    switch (id) {
        case 1 :
            if(parseInt(this.props.permisos[id-1].menu)==1){
                bandera=true;
            }
        break;
        case 6 :
            if(parseInt(this.props.permisos[id-1].menu)==1){
                bandera=true;
            }
        break;
         case 8 :
            if(parseInt(this.props.permisos[id-1].menu)==1){
                bandera=true;
            }
        break;
        case 9 :
            if(parseInt(this.props.permisos[id-1].menu)==1){
                bandera=true;
            }
        break;
        case 10 :
            if(parseInt(this.props.permisos[id-1].menu)==1){
                bandera=true;
            }
        break;
        case 11 :
            if(parseInt(this.props.permisos[id-1].menu)==1){
                bandera=true;
            }
        break;
        case 99 :
            if(parseInt(this.props.user.rol)==4){
                bandera=true;
            }
        break;
    }
    return bandera;
  }
  modulo(url,id){
    let bandera=false;

    if(id==0){
        bandera=true;

    }else{
        bandera=this.permisos(id);

    }
    if(bandera)
        {
            this.props.props.history.push('/app'+url);
            this.props.ocultar();

        }else{
             swal("Advertencia!", "No Tienes el Permiso para Esta Accion!", "error");
        }

  }
  nada(){}
    toggle_modal(index=0){  
          this.props.ocultar();
        this.setState({
            modal : !this.state.modal,
            menu: 0,
            submenu:0,
            titulo:catalogos[index],
            catalogo:index,         
        })
    }
    toggle_plazos(){    
         this.props.ocultar();
        this.setState({
            modal_plazos : !this.state.modal_plazos,
            menu: 0,
            submenu:0,      
        })
    }
    toggle_parametros(){    
         this.props.ocultar();
        this.setState({
            modal_parametros : !this.state.modal_parametros,
            menu: 0,
            submenu:0,      
        })
    }
    toggle_datos_factura(){ 
         this.props.ocultar();
        this.setState({
            modal_datos_facutra : !this.state.modal_datos_facutra,
            menu: 0,
            submenu:0,      
        })
    }

    toggle(menu,id) {
        let valor=0;

        if(menu===1){
            if(parseInt(this.state.menu)!==id)
            valor=id;
            this.setState({
              menu: valor
            });
        }else if(menu===2){
            if(parseInt(this.state.submenu)!==id)
            valor=id;
            this.setState({
              submenu: valor
            });

        }else if(menu ===4){
            if(parseInt(this.state.submenu)!==id)
            valor=id;
            this.setState({
              submenu: valor
            });
        }
    }
    
    toggleNavTab(tab) {

        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }

    render() {
        // console.log('tab activa---->',this.state.activeTab)
        return <ScrollArea className="nav-list-container  " horizontal={false} verticalScrollbarStyle={{width: '4px', marginLeft: '10px'}}>
                <ul className="list-unstyled nav-list clearfix">
                   
                    <li>
                        <TabContent activeTab={this.state.activeTab}>
                            <TabPane tabId={1}>
                                <ul className="list-unstyled nav-list clearfix">
                                    <li><div className="nav-list-title">Menu </div></li>
                                    <li className="mt-2 ml-2 text-left">
                                        <span onClick={() => { this.toggleNavTab(2); }} className="opciones_menu_responsivo">Catalogo</span>
                                    </li>
                                    <li className="mt-2 ml-2 text-left">
                                        <span onClick={() => { this.toggleNavTab(5); }} className="opciones_menu_responsivo">Movimientos</span>
                                    </li>
                                    <li className="mt-2 ml-2 text-left">
                                        <span onClick={() => { this.toggleNavTab(6); }} className="opciones_menu_responsivo">Tickets</span>
                                    </li>
                                    <li className="mt-2 ml-2 text-left">
                                        <span onClick={() => { this.toggleNavTab(7); }} className="opciones_menu_responsivo">Reportes</span>
                                    </li>
                                    <li className="mt-2 ml-2 text-left">
                                        <span onClick={() => { this.toggleNavTab(8); }} className="opciones_menu_responsivo">Parametros</span>
                                    </li>
                                </ul>
                            </TabPane>
                            <TabPane tabId={8}>
                                <ul className="list-unstyled nav-list clearfix">
                                    <li><div className="nav-list-title">Menu <span onClick={() => { this.toggleNavTab(1); }} className="opciones_menu_responsivo boton_atras">  <IconUndo size="18" className="icon-dashboard"/>Atras</span></div></li>
                                    <li className="mt-2 ml-2 text-left"> <span className="opciones_menu_responsivo" onClick={() => {this.permisos_modal(1);}}>Datos Factura E.</span> </li>
                                    <li className="mt-2 ml-2 text-left"> <span className="opciones_menu_responsivo" onClick={() => {this.permisos_modal(2);}}>Parametros Especiales</span> </li>
                                    <li className="mt-2 ml-2 text-left"> <span className="opciones_menu_responsivo" onClick={() => { this.modulo('/usuarios',6);}}>Usuarios</span> </li>
                                    <li className="mt-2 ml-2 text-left"> <span className="opciones_menu_responsivo" onClick={() => { this.modulo('/departamentos',6);}}>Departamentos</span> </li>
                                    <li className="mt-2 ml-2 text-left"> <span className="opciones_menu_responsivo" onClick={() => {this.modulo('/descuentos',99);}}>Tipo Clientes</span> </li>
                                    <li className="mt-2 ml-2 text-left"> <span className="opciones_menu_responsivo" onClick={() => {this.modulo('/facturacion/tipos_cambio',99);}}>Tipos de Cambios</span> </li>
                                    <li className="mt-2 ml-2 text-left"> <span className="opciones_menu_responsivo" onClick={() => {this.permisos_modal(3);}}>Plazos Vencimientos</span> </li>
                                </ul>
                            </TabPane>
                            <TabPane tabId={7}>
                                <ul className="list-unstyled nav-list clearfix">
                                     <li><div className="nav-list-title">Menu <span onClick={() => { this.toggleNavTab(1); }} className="opciones_menu_responsivo boton_atras">  <IconUndo size="18" className="icon-dashboard"/>Atras</span></div></li>
                                     <li className="mt-2 ml-2 text-left"> <span className="opciones_menu_responsivo" onClick={() => { this.modulo('',0);}} >Producción</span> </li>
                                     <li className="mt-2 ml-2 text-left"> <span className="opciones_menu_responsivo" onClick={() => { this.modulo('/eventos',0);}} > Eventos </span> </li>
                                     <li className="mt-2 ml-2 text-left"> <span className="opciones_menu_responsivo" onClick={() => { this.modulo('/reportes',0);}}> Reportes </span> </li>
                                </ul>
                            </TabPane>
                            <TabPane tabId={6}>
                                <ul className="list-unstyled nav-list clearfix">
                                     <li><div className="nav-list-title">Menu <span onClick={() => { this.toggleNavTab(1); }} className="opciones_menu_responsivo boton_atras">  <IconUndo size="18" className="icon-dashboard"/>Atras</span></div></li>
                                     <li className="mt-2 ml-2 text-left"> <span className="opciones_menu_responsivo" onClick={() => { this.modulo('/tickets',0);}} >Tickets</span> </li>
                                     <li className="mt-2 ml-2 text-left"> <span className="opciones_menu_responsivo" onClick={() => { this.modulo('/insidencias',0);}} > Incidencias </span> </li>
                                     <li className="mt-2 ml-2 text-left"> <span className="opciones_menu_responsivo" onClick={() => { this.modulo('/ComprasEspeciales',0);}}> Compras Especiales </span> </li>
                                </ul>
                            </TabPane>
                            <TabPane tabId={5}>
                                <ul className="list-unstyled nav-list clearfix">
                                     <li><div className="nav-list-title">Menu <span onClick={() => { this.toggleNavTab(1); }} className="opciones_menu_responsivo boton_atras">  <IconUndo size="18" className="icon-dashboard"/>Atras</span></div></li>
                                    <li className="mt-2 ml-2 text-left"> <span className="opciones_menu_responsivo" onClick={() => { this.modulo('/invoiceModule',0);}} >Facturas</span></li>
                                    <li className="mt-2 ml-2 text-left"> <span className="opciones_menu_responsivo" onClick={() => { this.modulo('/facturacion/C-A/Clientes',9);}} >C / A de Clientes</span></li>
                                    <li className="mt-2 ml-2 text-left"> <span className="opciones_menu_responsivo" onClick={() => { this.modulo('/facturacion/movimientoscompras',8);}} >Compras</span></li>
                                    <li className="mt-2 ml-2 text-left"> <span className="opciones_menu_responsivo" onClick={() => { this.modulo('/facturacion/C-A/Proveedores',10);}} >C / A de Proveedores</span></li>
                                    <li className="mt-2 ml-2 text-left"> <span className="opciones_menu_responsivo" onClick={() => { this.modulo('/facturacion/movimientosAlmacenes',11);}} >Almacén</span></li>
                                </ul>
                            </TabPane>
                            <TabPane tabId={2}>
                                <ul className="list-unstyled nav-list clearfix">
                                     <li><div className="nav-list-title">Menu <span onClick={() => { this.toggleNavTab(1); }} className="opciones_menu_responsivo boton_atras">  <IconUndo size="18" className="icon-dashboard"/>Atras</span></div></li>
                                    <li className="mt-2 ml-2 text-left">
                                        <span onClick={() => { this.modulo('/facturacion/proveedores',0); }} className="opciones_menu_responsivo">Proveedores</span>
                                    </li>
                                    <li className="mt-2 ml-2 text-left">
                                        <span onClick={() => { this.modulo('/clientes',0);}}  className="opciones_menu_responsivo">Clientes</span>
                                    </li>
                                    <li className="mt-2 ml-2 text-left">
                                        <span onClick={() => { this.modulo('/inventario',1);}}  className="opciones_menu_responsivo">Productos</span>
                                    </li>
                                    <li className="mt-2 ml-2 text-left">
                                        <span onClick={() => { this.toggleNavTab(3); }}  className="opciones_menu_responsivo">Catalogos</span>
                                    </li>
                                    <li className="mt-2 ml-2 text-left">
                                        <span onClick={() => { this.toggleNavTab(4); }}  className="opciones_menu_responsivo">CFDI 3.3</span>
                                    </li>
                                </ul>
                            </TabPane>
                            <TabPane tabId={3}>
                                <ul className="list-unstyled nav-list clearfix">
                                     <li><div className="nav-list-title">Menu <span onClick={() => { this.toggleNavTab(1); }} className="opciones_menu_responsivo boton_atras">  <IconUndo size="18" className="icon-dashboard"/>Atras</span></div></li>
                                    <li className="mt-2 ml-2 text-left"> <span className="opciones_menu_responsivo" onClick={() => {this.modulo('/facturacion/folios',0);}}>Folios de Documentos</span> </li>
                                    <li className="mt-2 ml-2 text-left"> <span className="opciones_menu_responsivo" onClick={() => {this.modulo('/categorias',1);}}>Categorias</span> </li>
                                    <li className="mt-2 ml-2 text-left"> <span className="opciones_menu_responsivo" onClick={() => {this.modulo('/facturacion/embarques',0);}}>Vias de Embarque</span> </li>
                                    <li className="mt-2 ml-2 text-left"> <span className="opciones_menu_responsivo" onClick={() => {this.modulo('/facturacion/lab',0);}}>Conceptos LAB</span> </li>
                                    <li className="mt-2 ml-2 text-left"> <span className="opciones_menu_responsivo" onClick={() => {this.modulo('/facturacion/impuestos',0);}}>Impuestos</span> </li>
                                    <li className="mt-2 ml-2 text-left"> <span className="opciones_menu_responsivo" onClick={() => {this.modulo('/facturacion/descuentos',0);}}>Descuentos</span> </li>
                                    <li className="mt-2 ml-2 text-left"> <span className="opciones_menu_responsivo" onClick={() => {this.modulo('/facturacion/almacenes',0);}}>Alamcenes</span> </li>
                                    <li className="mt-2 ml-2 text-left"> <span className="opciones_menu_responsivo" onClick={() => {this.modulo('/facturacion/lineas',0);}}>Lineas</span> </li>
                                    <li className="mt-2 ml-2 text-left"> <span className="opciones_menu_responsivo" onClick={() => {this.modulo('/facturacion/marcas',0);}}>Marcas</span> </li>
                                    <li className="mt-2 ml-2 text-left"> <span className="opciones_menu_responsivo" onClick={() => {this.modulo('/facturacion/estilos',0);}}>Estilos</span> </li>
                                    <li className="mt-2 ml-2 text-left"> <span className="opciones_menu_responsivo" onClick={() => {this.modulo('/facturacion/coloressabores',0);}}>Colores/Sabores</span> </li>
                                    <li className="mt-2 ml-2 text-left"> <span className="opciones_menu_responsivo" onClick={() => {this.modulo('/facturacion/medidas',0);}}>Medidas</span> </li>
                                    <li className="mt-2 ml-2 text-left"> <span className="opciones_menu_responsivo" onClick={() => {this.modulo('/facturacion/tipos_movimientos',0);}}>Tipo de Movimientos</span> </li>
                                    <li className="mt-2 ml-2 text-left"> <span className="opciones_menu_responsivo" onClick={() => {this.modulo('/facturacion/tipos_conceptos',0);}}>Tipos de Conceptos</span> </li>
                                    <li className="mt-2 ml-2 text-left"> <span className="opciones_menu_responsivo" onClick={() => {this.modulo('/facturacion/terminos_pago',0);}}>Terminos de Pago</span> </li>
                                </ul>
                            </TabPane>

                            <TabPane tabId={4}>
                                <ul className="list-unstyled nav-list clearfix">
                                     <li><div className="nav-list-title">Menu <span onClick={() => { this.toggleNavTab(1); }} className="opciones_menu_responsivo boton_atras">  <IconUndo size="18" className="icon-dashboard"/>Atras</span></div></li>
                                    <li className="mt-2 ml-2 text-left"> <span className="opciones_menu_responsivo" onClick={() => {this.toggle_modal(0);}}>Bancos</span> </li>
                                    <li className="mt-2 ml-2 text-left"> <span className="opciones_menu_responsivo" onClick={() => {this.toggle_modal(1);}}>Métodos de Pago</span> </li>
                                    <li className="mt-2 ml-2 text-left"> <span className="opciones_menu_responsivo" onClick={() => {this.toggle_modal(2);}}>Formas de Pago</span> </li>
                                    <li className="mt-2 ml-2 text-left"> <span className="opciones_menu_responsivo" onClick={() => {this.toggle_modal(3);}}>Códigos Postales</span> </li>
                                    <li className="mt-2 ml-2 text-left"> <span className="opciones_menu_responsivo" onClick={() => {this.toggle_modal(4);}}>Monedas</span> </li>
                                    <li className="mt-2 ml-2 text-left"> <span className="opciones_menu_responsivo" onClick={() => {this.toggle_modal(5);}}>Países</span> </li>
                                    <li className="mt-2 ml-2 text-left"> <span className="opciones_menu_responsivo" onClick={() => {this.toggle_modal(6);}}>Impuestos</span> </li>
                                    <li className="mt-2 ml-2 text-left"> <span className="opciones_menu_responsivo" onClick={() => {this.toggle_modal(7);}}>Régimen Fiscal</span> </li>
                                    <li className="mt-2 ml-2 text-left"> <span className="opciones_menu_responsivo" onClick={() => {this.toggle_modal(8);}}>Usos de CFDI</span> </li>
                                    <li className="mt-2 ml-2 text-left"> <span className="opciones_menu_responsivo" onClick={() => {this.toggle_modal(9);}}>Tasas o Cuotas</span> </li>
                                    <li className="mt-2 ml-2 text-left"> <span className="opciones_menu_responsivo" onClick={() => {this.toggle_modal(10);}}>Unidades</span> </li>
                                    <li className="mt-2 ml-2 text-left"> <span className="opciones_menu_responsivo" onClick={() => {this.toggle_modal(11);}}>Relaciones</span> </li>
                                    <li className="mt-2 ml-2 text-left"> <span className="opciones_menu_responsivo" onClick={() => {this.toggle_modal(12);}}>Productos y Servicios</span> </li>
                                    <li className="mt-2 ml-2 text-left"> <span className="opciones_menu_responsivo" onClick={() => {this.toggle_modal(13);}}>Aduanas</span> </li>
                                </ul>
                            </TabPane>

                        </TabContent>
                    </li>


                </ul>
                {this.state.modal&&
                     <ModalTablas
                    open={this.state.modal}
                    toggle={this.toggle_modal}                  
                    titulo={this.state.titulo}
                    catalogo={this.state.catalogo}
                    retorno={this.nada}
                />}
                {this.state.modal_plazos&&
                    <ModalPlazos
                    open={this.state.modal_plazos}
                    toggle={this.toggle_plazos}                 
                />
                }
                
                {this.state.modal_parametros&&
                <ModalParametros
                    open={this.state.modal_parametros}
                    toggle={this.toggle_parametros}                 
                />
                }
                {this.state.modal_datos_facutra&&
                <ModalDatosFactura
                    open={this.state.modal_datos_facutra}
                    toggle={this.toggle_datos_factura}                  
                />
                }
        </ScrollArea>
    }
}




export default (props) => (
    <nav className={`site-nav menu_responsivo ${props.mini ? 'mini' : ''}  `}>
        <NavHead {...props}/>
            <NavList user={props.user} props={props.props} ocultar={props.ocultar}   permisos={props.permisos}/>

    </nav>
);



// WEBPACK FOOTER //
// ./src/shared/components/nav/index.js